import { Panel } from 'react-bootstrap';
import { newLineSplit } from '../helper-functions';

interface IProps {
    title: string,
    name: string,
    address: string,
    email?: string,
    mobile?: string,
    star?: boolean,
}

const HeaderPanel = (props: IProps) => {
    return (
        <Panel bsStyle='primary'>
            <Panel.Heading>
                <h4 style={{ margin: 0 }}>{props.title} {props.star ? <img src='/images/gold-star-icon.svg' title='Lead Coordinator' style={{ width: 18, height: 18 }} /> : null}</h4>
            </Panel.Heading>

            <Panel.Body style={{ minHeight: 140 }}>
                <h4 style={{ margin: '0px 0px 10px 0px' }}>{props.name}</h4>
                {newLineSplit(props.address)}
            </Panel.Body>

            <Panel.Footer>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: 61 }}>
                    {props.email &&
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: 70 }}>Email:</div>
                            <div>{props.email}</div>
                        </div>
                    }

                    {props.mobile &&
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: 70 }}>Phone:</div>
                            <div>{props.mobile}</div>
                        </div>
                    }
                </div>
            </Panel.Footer>
        </Panel>
    );
}

export default HeaderPanel